import {AiOutlineUnorderedList} from 'react-icons/ai';
import {IconBaseProps} from "react-icons";

export const RatePlanIcon = (props: IconBaseProps) => {

    return (
        <AiOutlineUnorderedList {...props}/>
    );
};
